import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { SPECIFICATIONS } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Specifications = () => (
  <section id="specifications" data-testid="specifications-section" className="py-20 sm:py-28 bg-[#F4FAE8]">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading index="07" eyebrow="Specifications" title="Considered down to the last finish" center />
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="specifications-accordion">
          {SPECIFICATIONS.map((s, i) => (
            <AccordionItem
              key={s.section}
              value={s.section}
              data-testid={`spec-item-${i}`}
              className="bg-white border border-[#DCECC0] rounded-xl px-6 overflow-hidden data-[state=open]:border-[#84CC16] transition-colors duration-300"
            >
              <AccordionTrigger
                data-testid={`spec-trigger-${i}`}
                className="font-sub font-medium text-[15px] text-[#365314] hover:no-underline py-5"
              >
                <span className="flex items-center gap-4">
                  <span className="font-mono-spec text-[11px] text-[#84CC16]">{String(i + 1).padStart(2, "0")}</span>
                  {s.section}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-5">
                <ul className="space-y-2 pl-9">
                  {s.items.map((item) => (
                    <li key={item} className="text-sm text-[#4D7C0F] leading-relaxed flex gap-2.5">
                      <span className="text-[#84CC16] mt-0.5">✦</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
